import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function SendReportsPreview(props) {
  const {
    selectedReports,
    sendReports,
    cancelModal,
    runQC,
    badWoList,
    togglePreview,
    markCategory,
    batchUpdateReportStatus,
  } = props;
  const { qcNotRun, qcFailed, qcUnknown } = selectedReports;

  const renderQCElement = (report, index) => (
    <div key={index}>
      {index + 1}
      .
      {report.path}
    </div>
  );
  const headerText = () => {
    if (badWoList.length > 0) {
      return "Reports are not selected!";
    }

    if (qcNotRun.length > 0) {
      return "Reports are not QCed!";
    }

    return "Are you sure?";
  };

  return (
    <SweetAlert
      title=""
      confirmBtnBsStyle="btn-hide"
      onConfirm={() => {}}
      onCancel={togglePreview}
      openAnim={false}
    >
      <div className="sendReportsConfirmationModalContainer">
        <div className="sendReportsConfirmationModalHeader">
          <div className="sendReportsConfirmationModalHeaderText">{headerText()}</div>
        </div>

        <div className="sendReportsConfirmationModalBody">
          {badWoList.length > 0 && (
            <>
              All reports are NOT selected for the following workorders:
              <div className="sendReportsConfirmationModalQCList blockingCheck">
                {badWoList.map((report, index) => renderQCElement({ path: report }, index))}
              </div>
            </>
          )}

          {qcNotRun.length > 0 && (
            <>
              Not QCed:
              <div className="sendReportsConfirmationModalQCList qcNotRan">
                {qcNotRun.map((report, index) => renderQCElement(report, index))}
              </div>
            </>
          )}

          {qcFailed.length > 0 && (
            <>
              Failed QC:
              <div className="sendReportsConfirmationModalQCList qcFailed">
                {qcFailed.map((report, index) => renderQCElement(report, index))}
              </div>
            </>
          )}

          {qcUnknown.length > 0 && (
            <>
              Unknown Issue:
              <div className="sendReportsConfirmationModalQCList qcUnknown">
                {qcUnknown.map((report, index) => renderQCElement(report, index))}
              </div>
            </>
          )}
        </div>

        <div className="sendReportsConfirmationModalButtonContainer">
          <button type="button" className="sendReportsConfirmationModalButton" onClick={() => cancelModal()}>{badWoList.length > 0 && qcNotRun.length === 0 ? "Okay" : "Cancel"}</button>
          <button type="button" hidden={qcNotRun.length === 0} className="sendReportsConfirmationModalButton confirmBtn" onClick={() => runQC(qcNotRun.map((item) => ({ report_id: item.reportID })))}>Run QC</button>
          <button type="button" hidden={badWoList.length > 0 || markCategory !== null} className="sendReportsConfirmationModalButton confirmBtn" onClick={() => sendReports(true)}>Send Anyways</button>
          {markCategory === 1 && (<button type="button" className="sendReportsConfirmationModalButton confirmBtn" onClick={() => batchUpdateReportStatus(markCategory)}>Approve Anyways</button>)}
        </div>
      </div>
    </SweetAlert>
  );
}
